import { render, staticRenderFns } from "./EpBenefit.vue?vue&type=template&id=009eb43c&"
import script from "./EpBenefit.vue?vue&type=script&lang=js&"
export * from "./EpBenefit.vue?vue&type=script&lang=js&"
import style0 from "./EpBenefit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports